import * as apigw from "@/lib/apigw"

export const getNoticesDb = async (nextId?: string, opts?: any): Promise<any> => {
  const res = await apigw.request("/user/get-notices", { nextId }, opts)
  return res
}
